<div id="service-request-container" class="container-fluid">
  <div class="title-container">
    <span class="step-title">{{'service.chooseTheServices' | translate}}</span>
    <div class="mileage-container">
    
      <ng-container *ngIf="!(availableMileagesLoading$ | async) && (availableMileagesLoaded$ | async)">
        <span class="mileage-title">{{ 'service.mileage' | translate}}</span>
        <app-mileage-carousel class="app-mileage-carousel" [mileages]="availableMileages$ | async"
          [isVisible]="(selectedStep$ | async) === 1" [selectedMileage]="recommendedServicesByMileage$ | async"
          (mileageChange)="onMileageChange($event)"></app-mileage-carousel>
      </ng-container>
    </div>
  </div>

  <div class='own-vehicle-loader' *ngIf="(serviceOpcodesLoading$ | async) && (selectedStep$ | async) === 1">
     <app-loading size=".5"></app-loading>
  </div>
  <div class="row" *ngIf="!(serviceOpcodesLoading$ | async)  && (selectedStep$ | async) === 1 && !isTelematicsLoading">
    <div class="col-md-12 mb-2">
      <form [formGroup]="step" appConnectStore="serviceForm">
        <div class="d-flex mb-4 w-100" *ngIf="recommendedServicesAvailable$ | async">
          <span class="step-subtitle">{{ 'service.recommended' | translate}}</span>
          <div class="service-counter ml-3">{{recommendedServicesSelectedCount}}</div>
        </div>
        <div formArrayName="recommendedServices" *ngIf="recommendedServicesAvailable$ | async">
          <mat-expansion-panel *ngFor="let service of recommendedServicesArr?.controls, let i = index"
            [expanded]="service.value.expanded" (closed)="service.get('expanded').patchValue(false);"
            [formGroupName]="i" hideToggle>
            <mat-expansion-panel-header>
              <mat-panel-title>
                <div class="service-title-panel my-4 w-100">
                  <mat-checkbox class="service-checkbox d-flex mt-1 pt-2" disableRipple (click)="checkEvent($event)"
                    (change)="selectionChange($event,true,i)" formControlName="selected">
                  </mat-checkbox>
                  <div class="service-info d-flex">
                    <span class="service-name ml-4">{{service.value.serviceInfo.displayName}}</span>
                    <span *ngIf="service.value.serviceInfo.factoryServices && service.value.serviceInfo.factoryServices.length > 0 &&
                      service.value.serviceInfo?.factoryServices[0].factoryServicesDetails && service.value.serviceInfo?.factoryServices[0].factoryServicesDetails.length > 0"
                    class="service-tip-factory-details ml-4" (click)="viewFactoryDetails($event, service.value.serviceInfo)">
                    <ng-container *ngIf="service.value.serviceInfo?.factoryServices[0].vehicleDetails.make?.toLowerCase() !== 'scion'">{{ 'service.seePackageDetails' | translate}}</ng-container></span>
                  
                    <span *ngIf="service.value.serviceInfo.pricing.show
                                  && service.value.serviceInfo?.pricing?.discount?.isAvailable 
                                  && !service.value.serviceInfo.recommended?.isCoveredByToyotaCare"
                      class="service-tip-secondary ml-2">{{ 'service.special' | translate}}</span>
                      <!-- Toyota/Lexus maintenance covered-->
                    <span *ngIf="!isNTL && service.value.serviceInfo.recommended?.isCoveredByToyotaCare" 
                      class="service-covered ml-4 ml-md-auto">
                        <span *ngIf="isLexusDealer(service.value.serviceInfo)">{{ 'service.lexusComplimentaryMaintenance' |
                          translate}}</span>
                        <span *ngIf="!isLexusDealer(service.value.serviceInfo) && isMEXDealer">{{ 'service.toyotaComplimentaryMaintenance' |
                          translate}}</span>
                        <span *ngIf="!isLexusDealer(service.value.serviceInfo) && !isMEXDealer">{{ 'service.coveredByToyotaCare' |
                          translate}}</span>
                    </span>
                      <!-- Toyota/Lexus maintenance price setup-->
                    <span class="ask-advisor ml-md-auto" *ngIf="!isNTL && !service.value.serviceInfo.recommended.isCoveredByToyotaCare
                      && service.value.serviceInfo.pricing.show">
                      <span class="service-pricing-text" *ngIf="getPricingText(service.value.serviceInfo)"
                        [ngClass]="{'crossed-out-price mr-1': service.value.serviceInfo?.pricing?.discount?.isAvailable}">
                        {{getPricingText(service.value.serviceInfo) | translate}}
                      </span>
                      <span class="service-pricing-value"
                        [ngClass]="{'crossed-out-price mr-1': service.value.serviceInfo?.pricing?.discount?.isAvailable}">
                        {{getPricing(service.value.serviceInfo)}}
                      </span>
                      <span *ngIf="service.value.serviceInfo?.pricing?.discount?.isAvailable" class="ml-1 text-decoration-none">
                        {{service.value.serviceInfo?.pricing?.discount.price | currency: ('GLOBAL.CURRENCY' | translate)}}
                      </span> 
                    </span>
                      <!-- Toyota/Lexus maintenance price not setup-->
                      <span class="ask-advisor ml-md-auto" *ngIf="!isNTL && !service.value.serviceInfo.recommended.isCoveredByToyotaCare
                      && !service.value.serviceInfo.pricing.show">
                      <ng-template [ngTemplateOutlet]="askAdvisor"></ng-template>
                    </span>
                    <!-- NTL -->
                    <span *ngIf="isNTL" class="service-covered ml-4 ml-md-auto">
                      <!-- maintenance price setup -->
                      <span class="service-pricing ml-4 ml-md-auto" *ngIf="service.value.serviceInfo.pricing.show">
                        <span class="service-pricing-text" *ngIf="getPricingText(service.value.serviceInfo)"
                        [ngClass]="{'crossed-out-price mr-1': service.value.serviceInfo?.pricing?.discount?.isAvailable}">
                        {{getPricingText(service.value.serviceInfo) | translate}}
                        </span>
                        <span class="service-pricing-value"
                          [ngClass]="{'crossed-out-price mr-1': service.value.serviceInfo?.pricing?.discount?.isAvailable}">
                          {{getPricing(service.value.serviceInfo)}}
                        </span>
                        <span *ngIf="service.value.serviceInfo?.pricing?.discount?.isAvailable" class="ml-1 text-decoration-none">
                          {{service.value.serviceInfo?.pricing?.discount.price | currency: ('GLOBAL.CURRENCY' | translate)}}
                        </span> 
                      </span>
                      <!-- maintenance price not setup setup -->
                      <span class="ask-advisor ml-md-auto" *ngIf="!service.value.serviceInfo.pricing.show">
                        <ng-template [ngTemplateOutlet]="askAdvisor"></ng-template>
                      </span>
                    </span>
                    <span *ngIf="!service.value.serviceInfo.recommended.isCoveredByToyotaCare &&
                    (!service.value.serviceInfo?.opcodeType || service.value.serviceInfo?.opcodeType === 'other')
                    && service.value.serviceInfo.pricing.show"
                      class="service-pricing ml-4 ml-md-auto">
                      <span class="service-pricing-text" *ngIf="getPricingText(service.value.serviceInfo)"
                        [ngClass]="{'crossed-out-price mr-1': service.value.serviceInfo?.pricing?.discount?.isAvailable}">
                        {{getPricingText(service.value.serviceInfo) | translate}}
                      </span>
                      <span class="service-pricing-value"
                        [ngClass]="{'crossed-out-price mr-1': service.value.serviceInfo?.pricing?.discount?.isAvailable}">
                        {{getPricing(service.value.serviceInfo)}}
                      </span>
                      <span *ngIf="service.value.serviceInfo?.pricing?.discount?.isAvailable"
                        class="ml-1 text-decoration-none">
                        {{service.value.serviceInfo?.pricing?.discount.price | currency: ('GLOBAL.CURRENCY' | translate)}}
                      </span>
                    </span>
                  </div>
                </div>
                <mat-icon class="mat-icon-arrow-indicator mx-3">keyboard_arrow_right</mat-icon>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div *ngIf="!service.value.serviceInfo?.opcodeType || service.value.serviceInfo?.opcodeType === 'other'"
              class="service-details">
              @for(part of generatePTagsSSCrecall(service.value.serviceInfo); track part) {
                  <p class="custom-paragraph-ssc">{{ part }}</p>
              }
              <textarea *ngIf="_isAuthenticated()? false:!service.value.serviceInfo.commentsEnabled" rows="3" [ngClass]="{'invalid-border': service.invalid}"
                class="service-comments form-control mb-0" [placeholder]="'testDrive.enterCommentsHere' | translate" 
                formControlName="comments"></textarea>
              <span *ngIf="service.invalid" class="comments-warning">{{'service.commentsAreRequired' | translate}}</span>
            </div>
            <div *ngIf="service.value.serviceInfo?.opcodeType && service.value.serviceInfo?.opcodeType !== 'other'"
              class="service-details">
              <textarea rows="3" class="service-comments form-control mb-0" [placeholder]="'testDrive.enterCommentsHere' | translate"
              formControlName="comments">{{service.value.serviceInfo.description}}</textarea>
            </div>
            <div formArrayName='addOns' class="addon-service"
              *ngIf='service.value.serviceInfo.addOnOpcodes && service.value.serviceInfo.addOnOpcodes?.checked && service.value.serviceInfo.addOnOpcodes?.opcodes'>
              <span class="addon-text" *ngIf="service.value.serviceInfo.addOnOpcodes?.description!== undefined && service.value.serviceInfo.addOnOpcodes?.description !== ''; else upselltext">{{service.value.serviceInfo.addOnOpcodes?.description}}</span>
              <ng-template #upselltext>{{'opcodeServiceManagement.youMayAlsoLikeToGoFor' | translate}}</ng-template>
              <div class="row addon-list" *ngFor="let addon of getAddOns(i, true), let ind = index">
                <div class="service-info d-flex" [formGroupName]="ind">
                  <mat-checkbox class="addon-checkbox d-flex mt-1 pt-2" formControlName="selected" disableRipple
                    (click)="checkEvent($event)" (change)="addOnSelectionChange($event,true,addon.value.serviceInfo)">
                  </mat-checkbox>
                  <span class="service-name ml-4">{{addon.value.serviceInfo.displayName?
                    addon.value.serviceInfo.displayName :addon.value.serviceInfo.dmsDescription }}</span>
                 
                  <span *ngIf="addon.value.serviceInfo.pricing.show
                              && addon.value.serviceInfo?.pricing?.discount?.isAvailable"
                    class="service-tip-secondary ml-4">{{'service.special' | translate}}</span>
                  <span *ngIf="addon.value.serviceInfo.recommended.isCoveredByToyotaCare"
                    class="service-covered ml-4 ml-md-auto">
                    <span class="crossed-out-price mr-1"
                      *ngIf="addon.value.serviceInfo.pricing.show">
                      {{getPricing(service.value.serviceInfo)}}</span>
                      <span *ngIf="!isLexusDealer(addon.value.serviceInfo) && isMEXDealer">{{ 'service.toyotaComplimentaryMaintenance'
                        |translate}}</span>
                      <span *ngIf="isLexusDealer(addon.value.serviceInfo)">{{
                        'service.lexusComplimentaryMaintenance'|translate}}</span>
                      <span *ngIf="!isLexusDealer(service.value.serviceInfo) && !isMEXDealer">{{ 'service.coveredByToyotaCare'
                        |translate}}</span>
                    <span class="ask-advisor ml-1"
                      *ngIf="!(addon.value.serviceInfo.pricing.show)">
                      <ng-template [ngTemplateOutlet]="askAdvisor"></ng-template>
                    </span>
                  </span>
                  <span *ngIf="!addon.value.serviceInfo.recommended.isCoveredByToyotaCare
                                && addon.value.serviceInfo.pricing.show" class="service-pricing ml-4 ml-md-auto">
                    <span class="service-pricing-text" *ngIf="getPricingText(addon.value.serviceInfo)"
                      [ngClass]="{'crossed-out-price mr-1': addon.value.serviceInfo.pricing.show
                                                                && addon.value.serviceInfo?.pricing?.discount?.isAvailable}">
                      {{getPricingText(addon.value.serviceInfo) | translate}}
                    </span>
                    <span class="service-pricing-value"
                      [ngClass]="{'crossed-out-price mr-1':addon.value.serviceInfo?.pricing?.show
                                                                && addon.value.serviceInfo?.pricing?.discount?.isAvailable}">
                      {{getPricing(addon.value.serviceInfo)}}
                    </span>
                    <span *ngIf="addon.value.serviceInfo?.pricing?.discount?.isAvailable"
                      class="ml-1 text-decoration-none">
                      {{addon.value.serviceInfo?.pricing?.discount?.price | currency: ('GLOBAL.CURRENCY' | translate)}}
                    </span>
                  </span>
                </div>
              </div>
            </div>
          </mat-expansion-panel>
        </div>
        <div class="counter-section d-flex my-4 w-100" *ngIf="otherServicesAvailable$ | async">
          <div class="step-subtitle">{{ 'service.allServices' | translate}}</div>
          <div class="service-counter ml-3">{{regularServicesSelectedCount}}</div>
          <div class="step-deselect ml-4" (click)="clearSelections()">{{ 'service.deselectAll' | translate}}</div>
          <div class="d-flex d-md-none w-100"></div>
          <div class="d-flex ml-md-auto mt-4 mt-md-0 search-text">
            <mat-form-field appearance="outline">
              <!-- <mat-label>{{ 'service.search' | translate}}</mat-label> -->
              <mat-icon matPrefix>search</mat-icon>
              <input matInput #clearFilter (keyup)="filterServices($event.target.value)"
                placeholder="{{'service.searchForServices' | translate}}">
              <button mat-button matSuffix aria-label="Clear" (click)="clearServiceFilter()">
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </div>
        </div>
        <div formArrayName="allServices" *ngIf="otherServicesAvailable$ | async">
          <ng-container *ngFor="let service of allServicesArr?.controls, let i = index" [formGroupName]="i">
            <mat-expansion-panel *ngIf="!service.value.serviceInfo.isMiscellaneous && !service.value.hidden" [expanded]="service.value.expanded"
              (closed)="service.get('expanded').patchValue(false);" hideToggle>
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <div class="service-title-panel my-4 w-100">
                    <mat-checkbox class="service-checkbox d-flex mt-1 pt-2" disableRipple (click)="checkEvent($event)"
                      (change)="selectionChange($event,false,i)" formControlName="selected">
                    </mat-checkbox>
                    <div class="service-info d-flex">
                      <span class="service-name ml-4">{{service.value.serviceInfo.displayName? service.value.serviceInfo.displayName : service.value.serviceInfo.dmsDescription}}</span>
                    
                      <span *ngIf="service.value.serviceInfo.pricing.show
                                  && service.value.serviceInfo?.pricing?.discount?.isAvailable"
                        class="service-tip-secondary ml-2">{{'service.special' | translate}}</span>
                      <span *ngIf="service.value.serviceInfo.recommended?.isCoveredByToyotaCare"
                        class="service-covered ml-4 ml-md-auto">
                        <span class="crossed-out-price mr-1"
                          *ngIf="service.value.serviceInfo.pricing.show">
                          {{getPricing(service.value.serviceInfo)}}</span>
                          <span *ngIf="!isLexusDealer(service.value.serviceInfo) && !isMEXDealer">{{ 'service.coveredByToyotaCare' |
                            translate}}</span>
                          <span *ngIf="isLexusDealer(service.value.serviceInfo)">{{ 'service.lexusComplimentaryMaintenance' |
                            translate}}</span>
                          <span *ngIf="!isLexusDealer(service.value.serviceInfo) && isMEXDealer">{{ 'service.toyotaComplimentaryMaintenance' |
                            translate}}</span>
                      </span>
                      <span class="ask-advisor ml-md-auto test"
                      *ngIf="!service.value.serviceInfo.recommended?.isCoveredByToyotaCare
                            && !( service.value.serviceInfo.pricing.show)">
                    <ng-template [ngTemplateOutlet]="askAdvisor"></ng-template>
                    </span>
                      <span *ngIf="!service.value.serviceInfo.recommended?.isCoveredByToyotaCare
                      && service.value.serviceInfo.pricing.show"
                        class="service-pricing ml-4 ml-md-auto">
                        <span class="service-pricing-text" *ngIf="getPricingText(service.value.serviceInfo)"
                          [ngClass]="{'crossed-out-price mr-1': service.value.serviceInfo?.pricing?.discount?.isAvailable}">
                          {{getPricingText(service.value.serviceInfo) | translate}}
                        </span>
                        <span class="service-pricing-value"
                          [ngClass]="{'crossed-out-price mr-1': service.value.serviceInfo?.pricing?.discount?.isAvailable}">
                          {{getPricing(service.value.serviceInfo)}}
                        </span>
                        <span *ngIf="service.value.serviceInfo?.pricing?.discount?.isAvailable"
                          class="ml-1 text-decoration-none">
                          {{service.value.serviceInfo?.pricing?.discount.price | currency: ('GLOBAL.CURRENCY' | translate)}}
                        </span>
                      </span>
                    </div>
                  </div>
                  <mat-icon class="mat-icon-arrow-indicator mx-3">keyboard_arrow_right</mat-icon>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="service-details">
                <p *ngIf="service.value.serviceInfo.commentsEnabled">{{service.value.serviceInfo.description}}</p>
                <textarea *ngIf="service.value.serviceInfo.commentsEnabled" rows="3" [ngClass]="{'invalid-border': service.invalid}" class="service-comments form-control"
                  [placeholder]="'testDrive.enterCommentsHere' | translate" formControlName="comments" [hidden]="_isAuthenticated()? false:!service.value.serviceInfo.commentsEnabled"></textarea>
                <span *ngIf="service.invalid" class="comments-warning">{{'service.commentsAreRequired' | translate}}</span>
              </div>
              <div formArrayName='addOns' class="addon-service"  
                *ngIf='service.value.serviceInfo.isVisible && service.value.serviceInfo?.subComplaints && service.value.serviceInfo.subComplaints?.checked && service.value.serviceInfo.subComplaints?.complaintCodes'>
                  <div class="row addon-list" *ngFor="let code of getSubComplaints(service.value.serviceInfo),let i = index" >
                    <div class="service-info d-flex"  [formGroupName]="i">
                      <mat-checkbox class="addon-checkbox d-flex mt-1 pt-2"  disableRipple (click)="checkEvent($event)"
                      (change)="addOnSelectionChange($event,true,code)" 
                        formControlName="selected" >
                      </mat-checkbox>
                      <span class="service-name ml-4">{{code.displayName}}</span>
                    </div>
                  </div>
              </div>
              <div formArrayName='addOns' class="addon-service"
                *ngIf='service.value.serviceInfo.addOnOpcodes && service.value.serviceInfo.addOnOpcodes?.checked && service.value.serviceInfo.addOnOpcodes?.opcodes'>
                <span class="addon-text" *ngIf="service.value.serviceInfo.addOnOpcodes?.description!== undefined && service.value.serviceInfo.addOnOpcodes?.description !== ''; else upselltext">{{service.value.serviceInfo.addOnOpcodes?.description}}</span>
                <ng-template #upselltext>{{'opcodeServiceManagement.youMayAlsoLikeToGoFor' | translate}}</ng-template>
                <div class="row addon-list" *ngFor="let addon of getAddOns(i, false), let ind = index">
                  <div class="service-info d-flex" [formGroupName]="ind">
                    <mat-checkbox class="addon-checkbox d-flex mt-1 pt-2" formControlName="selected" disableRipple
                      (click)="checkEvent($event)" (change)="addOnSelectionChange($event,true,addon.value.serviceInfo)">
                    </mat-checkbox>
                    <span class="service-name ml-4">{{addon.value.serviceInfo.displayName?
                      addon.value.serviceInfo.displayName : addon.value.serviceInfo.dmsDescription }}</span>
                  
                    <span *ngIf="addon.value.serviceInfo.pricing.show
                                && addon.value.serviceInfo?.pricing?.discount?.isAvailable"
                      class="service-tip-secondary ml-4">{{'service.special' | translate}}</span>
                    <span *ngIf="addon.value.serviceInfo.recommended?.isCoveredByToyotaCare"
                      class="service-covered ml-4 ml-md-auto">
                      <span class="crossed-out-price mr-1"
                        *ngIf="addon.value.serviceInfo.pricing.show">
                        {{getPricing(addon.value.serviceInfo)}}</span>
                      <span *ngIf="!isLexusDealer(addon.value.serviceInfo) && !isMEXDealer">{{ 'service.coveredByToyotaCare' |
                        translate}}</span>
                      <span *ngIf="isLexusDealer(addon.value.serviceInfo)">{{ 'service.lexusComplimentaryMaintenance' |
                        translate}}</span>
                      <span *ngIf="!isLexusDealer(service.value.serviceInfo) && isMEXDealer">{{ 'service.toyotaComplimentaryMaintenance' |
                        translate}}</span>
                      <span class="ask-advisor ml-1"
                        *ngIf="!(addon.value.serviceInfo.pricing.show)">
                        <ng-template [ngTemplateOutlet]="askAdvisor"></ng-template>
                      </span>
                    </span>
                    <span *ngIf="!addon.value.serviceInfo.recommended?.isCoveredByToyotaCare
                                  && addon.value.serviceInfo.pricing.show" class="service-pricing ml-4 ml-md-auto">
                      <span class="service-pricing-text" *ngIf="getPricingText(addon.value.serviceInfo)"
                        [ngClass]="{'crossed-out-price mr-1': addon.value.serviceInfo.pricing.show
                                                                  && addon.value.serviceInfo?.pricing?.discount?.isAvailable}">
                        {{getPricingText(addon.value.serviceInfo) | translate}}
                      </span>
                      <span class="service-pricing-value"
                        [ngClass]="{'crossed-out-price mr-1':addon.value.serviceInfo?.pricing?.show
                                                                  && addon.value.serviceInfo?.pricing?.discount?.isAvailable}">
                        {{getPricing(addon.value.serviceInfo)}}
                      </span>
                      <span *ngIf="addon.value.serviceInfo?.pricing?.discount?.isAvailable"
                        class="ml-1 text-decoration-none">
                        {{addon.value.serviceInfo?.pricing?.discount?.price | currency: ('GLOBAL.CURRENCY' | translate)}}
                      </span>
                    </span>
                  </div>
                </div>
              </div>
            </mat-expansion-panel>
          </ng-container>
          <ng-container *ngFor="let miscservice of allServicesArr?.controls, let j = index" [formGroupName]="j">
            <div *ngIf="miscservice.value.serviceInfo.isMiscellaneous" class="misc-details">
              <p>{{miscservice.value.serviceInfo.description}}</p>
              <textarea rows="3" (keyup)="setMiscSelected(miscservice)"
                class="service-comments form-control mb-0"
                formControlName="comments" ></textarea>
            </div>
            </ng-container>
        </div>

      </form>
    </div>
  </div>
</div>

<ng-template #askAdvisor>
  {{ 'service.askAdvisor' | translate}}
  <mat-icon [title]="'service.pleaseContactTheDealerToKnowThePriceDetails' | translate" class="mat-info-icon">info_outline</mat-icon>
</ng-template>
